import { TasksMain } from 'components/featured/Tasks/TasksMain';
type MainProps = {
  clientScope?: {
    clientId?: string;
    clientName?: string;
  };
  teamScope?: {
    teamId?: string;
    teamName?: string;
  };
};
export const Tasks = ({ clientScope, teamScope }: MainProps) => {
  return (
    <div>
      <TasksMain clientScope={clientScope} teamScope={teamScope} />
    </div>
  );
};
